import { styled } from '@mui/material';

import BankIDLogo from '../../assets/images/bankID.svg';
import GjeldsregisteretLogo from '../../assets/images/gjeldsregisteret.png';
import TrustpilotLogo from '../../assets/images/trustpilot.png';

const PartnersContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  [theme.breakpoints.up('xl')]: {
    justifyContent: 'space-between',
  },
}));

const ImageContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  paddingTop: '12%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '50%',
  '&:nth-of-type(3), &:nth-of-type(4), &:nth-of-type(5)': {
    marginTop: theme.spacing(4),
  },
  [theme.breakpoints.up(500)]: {
    paddingTop: '8%',
  },
  [theme.breakpoints.up('sm')]: {
    width: '33%',
    '&:nth-of-type(3)': { marginTop: 0 },
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: '6%',
  },
  [theme.breakpoints.up('lg')]: {
    width: '20%',
    '&:nth-of-type(4), &:nth-of-type(5)': { marginTop: 0 },
  },
}));

const StyledImage = styled('img')<{
  variant?: 'gjeldsregisteret' | 'trustpilot' | 'bankID';
}>(({ theme, variant }) => ({
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  top: '50%',
  left: '50%',
  maxWidth: '90%',
  height: 'auto',
  [theme.breakpoints.up('sm')]: { minHeight: 20 },
  ...(variant === 'gjeldsregisteret' && {
    maxHeight: 40,
    [theme.breakpoints.up('md')]: { maxHeight: 50 },
  }),
  ...(variant === 'trustpilot' && {
    maxHeight: 50,
    [theme.breakpoints.up('md')]: { maxHeight: 70 },
  }),
  ...(variant === 'bankID' && {
    maxHeight: 20,
    [theme.breakpoints.up('md')]: { maxHeight: 30 },
  }),
}));

const items = [
  { src: GjeldsregisteretLogo, key: 'gjeldsregisteret' },
  { src: TrustpilotLogo, key: 'trustpilot' },
  { src: BankIDLogo, key: 'bankID' },
] as const;

const Partners = () => {
  return (
    <PartnersContainer>
      {items.map((item) => (
        <ImageContainer key={item.key}>
          <StyledImage src={item.src} alt={`${item.key} logo`} variant={item.key} loading="lazy" />
        </ImageContainer>
      ))}
    </PartnersContainer>
  );
};

export default Partners;
